import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import API_BASE_URL from './config';
import DealsSection from './DealsSection';
import { FaArrowLeft } from 'react-icons/fa';

const Dashboard = () => {
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const source = localStorage.getItem("role") === "customer" ? "user_signup_details" : "users";

    if (!userId || !source) {
      console.warn('User not logged in or missing source.');
      return;
    }

    fetch(`${API_BASE_URL}/api/user/coupons?userId=${userId}&source=${source}`)
      .then(res => res.json())
      .then(data => setCoupons(data))
      .catch(err => console.error('Error fetching coupons:', err));

    fetch(`${API_BASE_URL}/api/user/dashboard-summary?userId=${userId}&source=${source}`)
      .then(res => res.json())
      .then(data => setSummary(data))
      .catch(err => console.error('Error fetching summary:', err));
  }, []);


  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <button className="back-btn" onClick={() => navigate('/login')}>
          <FaArrowLeft />
        </button>
        <h1>Welcome to Your Dashboard</h1>
      </header>
    
      {summary && (
        <>
          {/* Section 1: Your Rewards Summary (Table) */}
          <section className="deals-list">
            <h2>Your Savings Summary</h2>
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Gold Points</th>
                  <th>Reward Points</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Savings this month</td>
                  <td>{summary.goldCoins}</td>
                  <td>{summary.rewardPoints}</td>
                </tr>
                <tr>
                  <td>Total Savings so far</td>
                  <td colSpan="2">₹{summary.totalSavings}</td>
                </tr>
                <tr>
                  <td>Total Deals Purchased</td>
                  <td colSpan="2">{summary.totalDeals}</td>
                </tr>
              </tbody>
            </table>
          </section>

          {/* Section 2: Reward Summary Box */}
          <div className="deals-list customer-rewards-card">
            <h3 className="rewards-title">Reward Summary</h3>

            <div className="reward-line">
              <span className="reward-label">Gold Redeemed</span>
              <span className="reward-value">₹180 (0.25g)</span>
            </div>

            <div className="reward-line">
              <span className="reward-label">Gold Unredeemed</span>
              <span className="reward-value">
                ₹120 <button className="small-btn">Redeem Now</button>
              </span>
            </div>

            <div className="reward-line">
              <span className="reward-label">Reward Unredeemed</span>
              <span className="reward-value">
                ₹60 <button className="small-btn">Redeem Now</button>
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <div className="gold-nav-wrapper">
            <button
              className="gold-nav-btn"
              onClick={() => navigate('/gold-dashboard')}
            >
              Go to DiscountDost Gold →
            </button>
          </div>
        </>
      )}

      <section className="deals-list">
        <h2>Your Purchased Coupons</h2>
        <table>
          <thead>
            <tr>
              <th>Coupon Code</th>
              <th>Deal Title</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map(coupon => (
              <tr key={coupon._id}>
                <td>{coupon.couponCode}</td>
                <td>{coupon.dealTitle}</td>
                <td>{coupon.status}</td>
                <td>
                  <button
                    className="action-btn"
                    onClick={() => navigate(`/coupon/${coupon.couponCode}`)}
                  >
                    View Coupon
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="available-deals">
        <DealsSection />
      </section>
    </div>
  );
};

export default Dashboard;
